exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog_text[data-v-e683f044],.dialog_title[data-v-e683f044]{display:flex;justify-content:center}.dialog_buttons[data-v-e683f044]{display:flex;justify-content:space-between}.header[data-v-e683f044]{display:flex;justify-content:space-between;align-items:center}.header .text[data-v-e683f044]{margin-top:5px;flex:2}.header .selectors[data-v-e683f044]{flex:3;display:flex;justify-content:space-around}.header .header_select[data-v-e683f044],.header .header_text_field[data-v-e683f044]{margin:10px}.selected_options[data-v-e683f044]{display:flex;justify-content:space-between;padding:0 1rem}", ""]);

// exports
